import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const AnalyticsFilters = ({ filters, onFilterChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const triggerTypeOptions = [
    { value: 'all', label: 'Todos los Tipos' },
    { value: 'client_threshold', label: 'Umbral de Cliente' },
    { value: 'service_milestone', label: 'Hito de Servicio' },
    { value: 'revenue_event', label: 'Evento de Ingresos' },
    { value: 'time_based', label: 'Basado en Tiempo' }
  ];

  const performanceRangeOptions = [
    { value: 'all', label: 'Todos los Rangos' },
    { value: 'high', label: 'Alto Rendimiento (>40% apertura)' },
    { value: 'medium', label: 'Rendimiento Medio (20-40% apertura)' },
    { value: 'low', label: 'Bajo Rendimiento (<20% apertura)' }
  ];

  const handleTriggerTypeChange = (e) => {
    const value = e?.target?.value === 'all' ? null : e?.target?.value;
    onFilterChange({ triggerType: value });
  };

  const handlePerformanceRangeChange = (e) => {
    onFilterChange({ performanceRange: e?.target?.value });
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-sm font-medium text-foreground">Filtros</h3>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          className="text-muted-foreground"
        />
      </div>

      {isExpanded && (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1">
              Tipo de Trigger
            </label>
            <Select
              value={filters?.triggerType || 'all'}
              onChange={handleTriggerTypeChange}
              className="w-full"
            >
              {triggerTypeOptions?.map(option => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </Select>
          </div>

          <div>
            <label className="block text-xs font-medium text-muted-foreground mb-1">
              Rango de Rendimiento
            </label>
            <Select
              value={filters?.performanceRange || 'all'}
              onChange={handlePerformanceRangeChange}
              className="w-full"
            >
              {performanceRangeOptions?.map(option => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnalyticsFilters;